import { BaseModel } from "../base/base.models";

export class ProductClassification extends BaseModel {
    code?: string;
    name?: string;
    priority?: number = 0;
    parent?: ProductClassification | string;
    image?: string;
}

export enum ProductClassificationType {
    ASSORTMENT, BRAND, CATEGORY, GROUP, MERCHANDISE_GROUP
}